module.exports = __webpack_public_path__ + "static/serenay_kurumsal_light-15edac25f0c025f97d50a2a948b6b104.pdf";